/** Single source of truth for displaying USD money. Always 2 decimals. */
export function formatCurrency(amount: number | null | undefined): string {
  const value = Number.isFinite(amount) ? (amount as number) : 0;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}
